module.exports = __webpack_public_path__ + "static/media/logo_kajave.390e33e4.svg";